<template>
  <b-card>
    <base-overlay :show="loading">
      <validation-observer ref="formRef">
        <b-form @submit.prevent="submit">
          <b-row>
            <b-col md="3">
              <validation-provider
                name="Name"
                rules="required"
              >
                <b-form-group
                  slot-scope="{ errors }"

                  label="Name"
                  label-for="name"
                >
                  <b-form-input
                    id="name"
                    v-model="formData.name "
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col md="3">
              <label for="zones">Zones</label>
              <v-select
                id="zones"
                v-model="formData.zone"
                placeholder="Select zone"
                :options="zonesOptions"
                label="name"
                :clearable="false"
                :loading="zonesLoading"
                @input="setServices"
              />
            </b-col>
            <b-col md="3">
              <label for="services">Services</label>
              <v-select
                id="services"
                v-model="formData.class_name"
                :disabled="!formData.zone"
                :options="servicesOptions"
                placeholder="Select service"
                :clearable="false"
              />
            </b-col>
            <b-col md="3">
              <validation-provider
                name="Time To Max Distance"
                rules="required"
              >
                <b-form-group
                  slot-scope="{ errors }"

                  label="Time To Max Distance (Sec)"
                  label-for="time_to_max_distance"
                >
                  <b-form-input
                    id="time_to_max_distance"
                    v-model="formData.time_to_max_distance"
                    type="number"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col md="3">
              <validation-provider
                name="Time To Increase Distance"
                rules="required"
              >
                <b-form-group
                  slot-scope="{ errors }"

                  label="Time To Increase Distance (Sec)"
                  label-for="time_to_increase_distance"
                >
                  <b-form-input
                    id="time_to_increase_distance"
                    v-model="formData.time_to_increase_distance"
                    type="number"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col md="3">
              <validation-provider
                name="Air Distance"
                rules="required"
              >
                <b-form-group
                  slot-scope="{ errors }"

                  label="Air Distance (KM)"
                  label-for="air_distance"
                >
                  <b-form-input
                    id="air_distance"
                    v-model="formData.air_distance"
                    type="number"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col md="3">
              <validation-provider
                name="Maximum Air Distance"
                rules="required"
              >
                <b-form-group
                  slot-scope="{ errors }"

                  label="Maximum Air Distance (KM)"
                  label-for="maximum_air_distance"
                >
                  <b-form-input
                    id="maximum_air_distance"
                    v-model="formData.maximum_air_distance"
                    type="number"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col md="3">
              <validation-provider
                name="Unit"
                rules="required"
              >
                <b-form-group
                  slot-scope="{ errors }"

                  label="Unit"
                  label-for="unit"
                >
                  <b-form-input
                    id="unit"
                    v-model="formData.unit"
                    disabled
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col md="3">
              <validation-provider
                name="Time Out"
                rules="required"
              >
                <b-form-group
                  slot-scope="{ errors }"

                  label="Time Out"
                  label-for="time_out"
                >
                  <b-form-input
                    id="time_out"
                    v-model="formData.time_out"
                    type="number"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col md="3">
              <validation-provider
                name="Concurrent Drivers"
                rules="required"
              >
                <b-form-group
                  slot-scope="{ errors }"

                  label="Concurrent Drivers"
                  label-for="concurrent_drivers"
                >
                  <b-form-input
                    id="concurrent_drivers"
                    v-model="formData.concurrent_drivers"
                    type="number"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
          </b-row>
          <b-button
            type="submit"
            variant="primary"
            :disabled="submitting"
          >
            Submit
          </b-button>
        </b-form>
      </validation-observer>
    </base-overlay>
  </b-card>
</template>

<script>
import {
  BCard, BForm, BButton, BFormInput, BFormGroup, BRow, BCol,
} from 'bootstrap-vue'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { required } from '@validations'
import { reactive, ref } from '@vue/composition-api'
import vSelect from 'vue-select'
import { errorNotification, successNotification } from '@/utils/toast-notifications'

export default {
  components: {
    BCard, BForm, ValidationObserver, ValidationProvider, BButton, BFormInput, BFormGroup, BRow, BCol, vSelect,
  },
  props: {
    isNew: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, ctx) {
    const zonesOptions = ref([])
    const servicesOptions = ref([])
    const formData = reactive({
      name: null,
      class_name: null,
      zone: null,
      time_to_max_distance: null,
      time_to_increase_distance: null,
      air_distance: null,
      maximum_air_distance: null,
      unit: 'KM',
      time_out: null,
      concurrent_drivers: null,
    })
    const zonesLoading = ref(false)
    const fetchZones = async () => {
      zonesLoading.value = true
      zonesOptions.value = await ctx.root.$store.dispatch('zones/fetchZones')
      zonesLoading.value = false
    }
    const setServices = () => {
      formData.class_name = null
      servicesOptions.value = formData.zone.services
    }
    const formRef = ref(null)
    const submitting = ref(false)
    const submit = async () => {
      const valid = await formRef.value.validate()
      if (!valid) return
      if (!formData.zone) {
        errorNotification('Select Zone')
        return
      }
      if (!formData.class_name) {
        errorNotification('Select Service')
        return
      }
      submitting.value = true
      try {
        const temp = {
          ...formData,
          zone: `Jordan::${formData.zone.city}`,
        }
        if (props.isNew) {
          await ctx.root.$store.dispatch('dispatch/createDispatchConfig', temp)
        } else {
          await ctx.root.$store.dispatch('dispatch/editDispatchConfig', {
            data: temp,
            id: ctx.root.$route.params.id,
          })
        }
        ctx.root.$router.push('/dispatch-configurations')
        successNotification('Submitted')
      } catch (error) {
        errorNotification('Something went wrong')
      }
      submitting.value = false
    }
    const loading = ref(false)

    const init = async () => {
      if (!props.isNew) {
        loading.value = true
        await fetchZones()
        const result = await ctx.root.$store.dispatch('dispatch/getDispatchConfig', ctx.root.$route.params.id)
        const temp = result.data.data
        Object.keys(temp).forEach(key => {
          if (key in formData) {
            if (key === 'zone') {
              const city = temp[key].split('::')[1]
              formData[key] = city
            } else {
              formData[key] = temp[key]
            }
          }
        })
        loading.value = false
      } else {
        fetchZones()
      }
    }
    init()
    return {
      required,
      formRef,
      formData,
      submitting,
      submit,
      zonesOptions,
      servicesOptions,
      setServices,
      zonesLoading,
      loading,
    }
  },
}
</script>
